import Dispatcher from '../dispatcher';

export enum MicrophoneState {
  Pending, // We don't know the microphone state yet.
  Enabled, // The microphone is enabled. We can start recording.
  Disabled // The microphone is disabled because the user didn't grant us permissions.
}

export const RecordingActionTypes = {
    SetMicrophoneStateAction: "RECORDING_SET_MICROPHONESTATE",
    SetRecorderReadyAction: "RECORDING_SET_READY",
    SetRecorderIsPaused: "RECORDING_SET_ISPAUSED",
    RevertStateAction: "RECORDING_REVERT_STATE",
    SetWarningDismissedAction: "RECORDING_SET_WARNING_DISMISSED"
};

export function SetRecorderReadyInStore(isReady: boolean) {
    Dispatcher.dispatch({
      type: RecordingActionTypes.SetRecorderReadyAction,
      payload: isReady
    });
}

export function SetRecorderIsPausedInStore(isPaused: boolean) {
    Dispatcher.dispatch({
      type: RecordingActionTypes.SetRecorderIsPaused,
      payload: isPaused
    });
}

export function SetMicrophoneStateInStore(micState: MicrophoneState) {
  Dispatcher.dispatch({
    type: RecordingActionTypes.SetMicrophoneStateAction,
    payload: micState
  });
}

export function SetWarningDismissedInStore() {
  Dispatcher.dispatch({
    type: RecordingActionTypes.SetWarningDismissedAction,
    payload: true
  });
}